// extracted by css-extract-rspack-plugin
export default {"actions":"SavedViewActions-module__actions__xj4Iu"};